// frontend/src/components/AdminTeamDetail/ProgressOverlay.js
import React from 'react';

const ProgressOverlay = ({ isProcessing, current, total, title = 'Processing...' }) => {
    if (!isProcessing) return null;

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full mx-4 text-center">
                <div className="mb-4 text-mjwc-primary">
                    <svg className="animate-spin h-12 w-12 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
                <p className="text-gray-600 mb-6">
                    Processing <span className="font-mono font-bold text-mjwc-primary">{current}</span> of <span className="font-mono font-bold">{total}</span>
                </p>
                <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 overflow-hidden">
                    <div
                        className="bg-mjwc-primary h-2.5 rounded-full transition-all duration-300 ease-out"
                        style={{ width: `${(current / total) * 100}%` }}
                    ></div>
                </div>
                <p className="text-xs text-gray-400">Please do not close this window</p>
            </div>
        </div>
    );
};

export default ProgressOverlay;
